function handleCheckboxes(container) {
  for (const element of container) {
    const termName = element.querySelector('.term-name');
    const checkbox = element.querySelector('input[type="checkbox"]');
    const customCheckbox = element.querySelector('.checkbox-custom');


    termName.addEventListener('click', () => {
      checkbox.checked = !checkbox.checked;
      customCheckbox.classList.toggle('checked');
      termName.classList.toggle('current');
    })
  }
}

export default handleCheckboxes;